








































import { Component, Vue } from 'vue-property-decorator'
import BlkCarousel from '~/components/BlkCarousel.vue'
import BlkSlide from '~/components/BlkSlide.vue'
import BlkFallbackedImg from '~/components/BlkFallbackedImg.vue'

interface ReasonType {
  title: string
  text1: string
  text2: string
  text3: string
  text4: string
  image: string
  imagefback: string
  imagealt: string
}

@Component({
  components: {
    BlkCarousel,
    BlkSlide,
    BlkFallbackedImg
  },
  name: 'BlkWhyBalkoCarousel'
})
export default class extends Vue {
  reasons: ReasonType[] = [
    {
      title: this.$root.$tc('learnMore.why.riskControl.title'),
      text1: this.$root.$tc('learnMore.why.riskControl.text1'),
      text2: this.$root.$tc('learnMore.why.riskControl.text2'),
      text3: this.$root.$tc('learnMore.why.riskControl.text3'),
      text4: '',
      image: '/static/images/learn-more/blkjenga.webp',
      imagefback: '/static/images/learn-more/blkjenga.jpg',
      imagealt: this.$root.$tc('learnMore.why.riskControl.altText')
    },
    {
      title: this.$root.$tc('learnMore.why.risks.title'),
      text1: this.$root.$tc('learnMore.why.risks.text1'),
      text2: this.$root.$tc('learnMore.why.risks.text2'),
      text3: this.$root.$tc('learnMore.why.risks.text3'),
      text4: this.$root.$tc('learnMore.why.risks.text4'),
      image: '/static/images/learn-more/scott-graham.webp',
      imagefback: '/static/images/learn-more/scott-graham.jpg',
      imagealt: this.$root.$tc('learnMore.why.risks.altText')
    },
    {
      title: this.$root.$tc('learnMore.why.security.title'),
      text1: this.$root.$tc('learnMore.why.security.text1'),
      text2: this.$root.$tc('learnMore.why.security.text2'),
      text3: '',
      text4: '',
      image: '/static/images/learn-more/mobile-yellow.webp',
      imagefback: '/static/images/learn-more/mobile-yellow.jpg',
      imagealt: this.$root.$tc('learnMore.why.security.altText')
    }
  ]
}
